var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldGridLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.53 17.15c0-1.93-.98-2.9-2.9-2.9s-2.9.98-2.9 2.9v.16c-1.05.26-1.47.98-1.47 2.42v.74c0 1.85.69 2.53 2.53 2.53h3.68c1.85 0 2.53-.69 2.53-2.53v-.74c0-1.43-.42-2.16-1.47-2.42v-.16zm-1.39 0v.05H17.1v-.05c0-1.03.23-1.52 1.52-1.52s1.52.49 1.52 1.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.8H3.498a1 1 0 0 1-.907-1.423C3.947 3.471 5.666 2.012 7.75 2v4.8a1 1 0 0 1-1 1zM16.25 6.8V3.438a1 1 0 0 1 1.385-.923c2.629 1.098 4.06 2.486 4.295 4.165.08.59-.4 1.12-1 1.12h-3.68a1 1 0 0 1-1-1zM7.616 21.173c-.314.545-.646.794-.996.748-2.89-.43-4.58-2.46-4.62-5.62h4.75a1 1 0 0 1 1 1v3.372a1 1 0 0 1-.134.5zM2 10.3v3.5a1 1 0 0 0 1 1h3.75a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zM9.25 10.3v3.5a1 1 0 0 0 1 1h3.27a1 1 0 0 0 .47-.116c.506-.269.76-.563.76-.883v-3.5a1 1 0 0 0-1-1h-3.5a1 1 0 0 0-1 1zM9.25 3v3.8a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-3.5a1 1 0 0 0-1 1z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGridLock);
export default __webpack_public_path__ + "static/media/vuesax-bold-grid-lock.1b3315e456f8fdad0fb7b81824d3d472.svg";
export { ForwardRef as ReactComponent };